export class ImageSnippet {
  constructor(name: string, src?: string | ArrayBuffer | undefined) {
    this.name = name;
    this.src = src;
  }
  name: string;
  src: string | ArrayBuffer | undefined;
}
